export default "__VITE_ASSET__qXH2X96X__"